import React from 'react';
import logo from '../assets/bangu_odonto_new.png';
import { getClinicNumbers } from '../utils/clinicNumbers';

const Footer = () => {
  const { years } = getClinicNumbers();

  return (
  <footer className="site-footer" id="contact">
    <div className="foot-top">
      <div className="foot-brand">
        <img className="foot-logo" src={logo} alt="Bangu Odonto Clínica" />
        <p>
          Seu sorriso em destaque. Há {years} anos cuidando de cada paciente da zona oeste
          do Rio com técnica, honestidade e carinho.
        </p>
      </div>

      <div className="foot-col">
        <h4>Navegar</h4>
        <ul>
          <li><a href="#sobre">Sobre</a></li>
          <li><a href="#servicos">Serviços</a></li>
          <li><a href="#equipe">Equipe</a></li>
          <li><a href="#depoimentos">Depoimentos</a></li>
          <li><a href="#facebook">Facebook</a></li>
          <li><a href="#casos">Casos</a></li>
          <li><a href="#localizacao">Localização</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#marcar">Marcar consulta</a></li>
        </ul>
      </div>

      <div className="foot-col">
        <h4>Contato</h4>
        <ul>
          <li>Rua Silva Cardoso, 346</li>
          <li>Bangu · Rio de Janeiro · RJ</li>
          <li><a href="tel:+5521978982711">(21) 97898-2711</a></li>
          <li><a href="mailto:banguodontoclinica@gmail.com">banguodontoclinica@gmail.com</a></li>
        </ul>
      </div>

      <div className="foot-col">
        <h4>Horário</h4>
        <ul>
          <li>Seg – Sex · 08h30 às 18h</li>
          <li>Sábado · 08h30 às 12h</li>
          <li>Domingo · Fechado</li>
        </ul>
        <div style={{ marginTop: 28 }}>
          <h4>Redes sociais</h4>
          <div className="social-links">
            <a href="https://www.instagram.com/banguodontoclinica" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r=".8" fill="currentColor" />
              </svg>
            </a>
            <a href="https://www.facebook.com/banguodontoclinica" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 22v-8h3l1-4h-4V7.5c0-1 .3-1.5 1.5-1.5H17V2.3c-.6-.1-1.7-.3-2.7-.3C11.5 2 10 3.7 10 6.8V10H7v4h3v8h3Z" />
              </svg>
            </a>
            <a href="https://wa.me/5521978982711" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4a10 10 0 0 0-15.7 12L3 21l5.2-1.3A10 10 0 1 0 20 4ZM12 19.3a7.4 7.4 0 0 1-3.9-1.1l-.3-.2-2.8.7.8-2.7-.2-.3A7.4 7.4 0 1 1 19.4 12 7.4 7.4 0 0 1 12 19.3Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div className="foot-big">
      Bangu <em>Odonto</em>
    </div>

    <div className="foot-bottom">
      <div>© {new Date().getFullYear()} Bangu Odonto Clínica · Responsável técnico: Dr. Marcio Caetano do Valle · CRO-RJ 26606 · EPAO 6658 · Todos os direitos reservados</div>
      <div>Rua Silva Cardoso, 346 · Bangu · RJ</div>
    </div>
  </footer>
  );
};

export default Footer;
